import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kyc.css';
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import { setPersonalInfo, setSaveData } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
import { Link } from "react-router-dom";
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import tokenErrorHandler from "../tokenErrorHandler";
import RegisterRetialerHeader from "../HeaderComponent/RegisterRetialerHeader";
import { setBranchAddress, setIfscCode, setSelectedBankName } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class UploadID extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadErrorMessage: '',
            docs: [],
            panNo: '',
            panUrl: '',
            panUploadErrMsg: '',
            panErrMsg: '',
            panUplodMsg: '',
            aadhaar: '',
            aadhaarUrl: '',
            aadhaarUploadErrMsg: '',
            aadhaarErrMsg: '',
            aadhaarUploadMsg: '',
            profileUrl: '',
            profilePhotoErrMsg: '',
            profileUploadMsg: '',
            shopDetails: null,

            saveDataErr: '',
            progress: ''

        }
    }


    componentDidMount() {
        store.dispatch(setIfscCode(''));
        store.dispatch(setBranchAddress(''));
        store.dispatch(setSelectedBankName(''));

        this.getSessionDetails();
    }
    componentWillUnmount() {
    }


    getSessionDetails = () => {
        // const headers = {
        //     'Authorization': 'Bearer ' + this.props.token,
        //     'client-id': this.props.agentInfo.id
        // };

        httpClient.get('/api/v1/retailer/onboard/session/' + this.props.registerRetailerResponse.sessionId
            // , { headers }
        ).then((response) => {
            console.log('session Id retailer response' + JSON.stringify(response.data));

            var docs = [];
            if (response.data != null) {
                if (response.data.kycInfo != null) {
                    docs = response.data.kycInfo.docs;
                }
            }
            if (docs.length > 0) {

                this.setState({
                    docs: docs
                })
                docs.map(doc => {
                    if (doc.type == 'PAN_CARD') {
                        this.setState({
                            panNo: doc.id,
                        })

                        if (doc.url != null) {
                            this.setState({
                                panUrl: doc.url,
                                panUplodMsg: 'Successfully Uploaded Pan'
                            })
                        }
                    }
                    if (doc.type == 'AADHAAR_CARD') {
                        this.setState({
                            aadhaar: doc.id,
                        })
                        if (doc.url != null) {
                            this.setState({
                                aadhaarUrl: doc.url,
                                aadhaarUploadMsg: 'Successfully Uploaded Aadhaar'
                            })
                        }
                    }
                })

            }
            if (response.data.personalInfo != null) {
                if (response.data.personalInfo.selfie != null) {
                    this.setState({
                        profileUrl: response.data.personalInfo.selfie,
                        profileUploadMsg: 'Successfully Uploaded Profile Photo'
                    })
                }
            }

            if (response.data.personalInfo != null) {
                if (response.data.personalInfo.fname != null) {
                    var personalInfo = {
                        gender: response.data.personalInfo.gender,
                        fname: response.data.personalInfo.fname,
                        lname: response.data.personalInfo.lname,
                        email: response.data.personalInfo.email,
                        mobile: response.data.personalInfo.mobile,
                        dob: response.data.personalInfo.dob,
                        address: null,
                        selfie: response.data.personalInfo.selfie,

                    }
                    store.dispatch(setPersonalInfo(personalInfo))
                }
            }
            this.setState({
                shopDetails: response.data.shopDetails
            })

        }).catch(error => {
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

            }

        });
    }
    dropHandler = (ev) => {
        console.log('File(s) dropped');
        ev.preventDefault();
        if (ev.dataTransfer.items) {
            for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                if (ev.dataTransfer.items[i].kind === 'file') {
                    var file = ev.dataTransfer.items[i].getAsFile();
                    console.log('... file[' + i + '].name = ' + file.name);
                }
            }
        } else {
            for (var i = 0; i < ev.dataTransfer.files.length; i++) {
                console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
            }
        }
    }
    dragOverHandler = (ev) => {
        console.log('File(s) in drop zone');
        ev.preventDefault();
    }

    uploadDoc = (event, type) => {
        if (type == 'PAN') {
            this.setState({
                panUploadErrMsg: '',
                panUplodMsg: '',
                panUrl: '',
            })
        }
        if (type == 'Aadhaar') {
            this.setState({
                aadhaarUploadErrMsg: '',
                aadhaarUploadMsg: '',
                aadhaarUrl: '',
            })
        }
        if (type == 'profile') {
            this.setState({
                profilePhotoErrMsg: '',
                profileUploadMsg: '',
                profileUrl: ''
            })
        }


        if (event != null) {
            if (event.target != null) {
                console.log('event.....' + JSON.stringify(event.target.files[0].type));
                if (event.target.files[0].type.includes("image/jpeg")
                    || event.target.files[0].type.includes("image/gif")
                    || event.target.files[0].type.includes("image/png")
                    || event.target.files[0].type.includes("image/jpg")
                    || event.target.files[0].type.includes("application/pdf")) {
                    // if (parseInt(event.target.files[0].size / 1000) < 10 * 1024) {

                    if (event.target.files[0] != null) {

                        console.log('event.target.files[0]' + URL.createObjectURL(event.target.files[0]));
                        this.setState({
                            selectedFile: URL.createObjectURL(event.target.files[0])
                        });
                        this.onFileUpload(event.target.files[0], type);
                    }
                    // } else {
                    //     console.log("file size is greater than 10 MB");
                    //     this.setState({
                    //         uploadErrorMessage: 'file size is greater than 10 MB'
                    //     })
                    // }
                } else {
                    console.log("file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported");
                    if (type == 'PAN') {
                        this.setState({
                            panUploadErrMsg: "file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported"
                        })
                    } else if (type == 'Aadhaar') {
                        this.setState({
                            aadhaarUploadErrMsg: "file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported"
                        })
                    } else if (type == 'profile') {
                        this.setState({
                            profilePhotoErrMsg: "file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported"
                        })
                    }
                }
            }
        }
    }

    onFileUpload = (value, typeVal) => {
        var fileName = uuidv4() + value.name;

        console.log('file name::' + value.name);

        const formData = new FormData();

        formData.append(
            "doc", value
        );
        formData.append(
            "name", fileName
        );
        formData.append(
            "type", value.type
        );

        // const headers = {
        //     'Authorization': 'Bearer ' + this.props.token,
        //     'client-id': this.props.agentInfo.id
        //     , 'role': this.props.clientRole
        // }
        fetch('/api/v1/document', {
            method: 'post',
            body: formData,
            // headers: headers
        }).then(res => res.json())
            .then(data => {

                if (data.id != null && data.id != undefined && data.id != '') {
                    this.setState({
                        imageUrl: fileName,
                        uploadedDocType: typeVal,
                        uploadedMsg: typeVal + ' uploaded successfully'
                    })

                    if (typeVal == 'PAN') {
                        this.setState({
                            panUrl: data.href,
                            panUplodMsg: 'Successfully Uploaded Pan'
                        })
                    }
                    if (typeVal == 'Aadhaar') {
                        this.setState({
                            aadhaarUrl: data.href,
                            aadhaarUploadMsg: 'Successfully Uploaded Aadhaar'
                        })
                    }
                    if (typeVal == 'profile') {
                        this.setState({
                            profileUrl: data.href,
                            profileUploadMsg: 'Successfully Uploaded Profile Photo'
                        })
                    }
                    if (typeVal != 'profile') {
                        var kycDoc = {
                            type: typeVal == 'PAN' ? 'PAN_CARD' : typeVal == 'Aadhaar' && 'AADHAAR_CARD',
                            id: typeVal == 'PAN' ? this.state.panNo : typeVal == 'Aadhaar' && this.state.aadhaar,
                            url: data.href
                        }

                        if (this.state.docs.length > 0) {
                            this.state.docs.map(doc => {
                                if (doc.type == kycDoc.type) {
                                    const index = this.state.docs.indexOf(doc);
                                    if (index > -1) { // only splice array when item is found
                                        this.state.docs.splice(index, 1); // 2nd parameter means remove one item only
                                    }
                                }
                            })
                        }
                        this.state.docs.push(kycDoc);
                    }

                    if (typeVal == 'profile') {
                        var personalInfo = {
                            gender: this.props.personalInfo.gender,
                            fname: this.props.personalInfo.fname,
                            lname: this.props.personalInfo.lname,
                            email: this.props.personalInfo.email,
                            mobile: this.props.personalInfo.mobile,
                            dob: this.props.personalInfo.dob,
                            address: null,
                            selfie: data.href
                        }
                        store.dispatch(setPersonalInfo(personalInfo))
                    }
                } else {
                    if (typeVal == 'PAN') {
                        this.setState({
                            panUploadErrMsg: "Something went wrong!"
                        })
                    } else if (typeVal == 'Aadhaar') {
                        this.setState({
                            aadhaarUploadErrMsg: "Something went wrong!"
                        })
                    } else if (typeVal == 'profile') {
                        this.setState({
                            profilePhotoErrMsg: "Something went wrong!"
                        })
                    }
                }

            }).catch(errorx => {
                if (typeVal == 'PAN') {
                    this.setState({
                        panUploadErrMsg: "Something went wrong!"
                    })
                } else if (typeVal == 'Aadhaar') {
                    this.setState({
                        aadhaarUploadErrMsg: "Something went wrong!"
                    })
                } else if (typeVal == 'profile') {
                    this.setState({
                        profilePhotoErrMsg: "Something went wrong!"
                    })
                }
                console.log('file upload error..' + errorx);
            });
    }

    removeImage = (event) => {
        console.log('removeImage');
        this.setState({
            removeStatus: true,
            selectedFile: null
        })
    }

    enterPANNo = (event) => {
        this.setState({
            panErrMsg: '',
            panNo: event.target.value
        })
    }
    enterAadhaar = (event) => {
        this.setState({
            aadhaarErrMsg: '',
            aadhaar: event.target.value
        })
    }

    saveDataValidation = () => {

        this.setState({
            panErrMsg: '',
            aadhaarErrMsg: '',
            saveDataErr: ''
        })
        var aadhRegx = /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/;
        var panCardRegex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
        var aadhaarVlidaion = false;
        var pancardValidation = false;
        var kycDocValidation = false;
        var profilePhotoValidation = false;

        // if (aadhRegx.test(this.state.aadhaar) && this.state.aadhaar != '') {
        //     aadhaarVlidaion = true;
        // } else {

        //     this.setState({
        //         aadhaarErrMsg: 'Please enter correct aadhhar no in xxxx xxxx xxxx format.'
        //     })
        // }

        if (this.state.aadhaar != '' &&
            (this.state.aadhaar.length == 12 || this.state.aadhaar.length == 16)) {
            aadhaarVlidaion = true;
        } else {
            this.setState({
                aadhaarErrMsg: 'Please enter valid Aadhaar/VID'
            })
        }


        if (panCardRegex.test(this.state.panNo) && this.state.panNo != '') {
            pancardValidation = true;
        } else {
            this.setState({
                panErrMsg: 'Please enter correct PAN no.'
            })
        }


        if (this.state.docs.length == 2) {
            kycDocValidation = true;
        } else {
            var docs1 = ['PAN_CARD', 'AADHAAR_CARD'];
            var docs2 = [];
            if (this.state.docs.length == 0) {

                this.setState({
                    panUploadErrMsg: "Upload PAN",
                    aadhaarUploadErrMsg: "Upload Aadhaar",
                })

            } else {

                this.state.docs.map(doc => {
                    docs2.push(doc.type);
                })



                // make a Set to hold values from namesToDeleteArr
                var namesToDeleteSet = new Set(docs2);

                // use filter() method
                // to filter only those elements
                // that need not to be deleted from the array
                var newArr = docs1.filter((name) => {
                    // return those elements not in the namesToDeleteSet
                    return !namesToDeleteSet.has(name);
                });
                newArr.map(elem => {
                    if (elem == 'PAN_CARD') {
                        this.setState({
                            panUploadErrMsg: "Upload PAN",
                        })
                    } else if (elem == 'AADHAAR_CARD') {
                        this.setState({
                            aadhaarUploadErrMsg: "Upload Aadhaar",
                        })
                    }
                })
            }
        }
        if (this.props.personalInfo.selfie != ''
            && this.props.personalInfo.selfie != undefined
            && this.props.personalInfo.selfie != null
        ) {
            profilePhotoValidation = true;
        } else {
            this.setState({
                profilePhotoErrMsg: "Upload profile photo",
            })
        }
        if (pancardValidation == true && aadhaarVlidaion == true && kycDocValidation == true &&
            profilePhotoValidation == true) {
            return true;
        } else {

            return false;
        }

    }

    saveData = (event) => {
        event.preventDefault();
        this.setState({
            saveDataErr: '',
            progress: 'loading'
        })

        if (this.saveDataValidation() == true) {
            var saveDataUrl = '/api/v1/retailer/onboard/session/save';

            var header = {
                msgType: "CREATE_ORDER",
                service: "KYC",
                src: "register-retailer",
                dst: "register-retailer",
                channel: "API",
                requesterId: 'W9853028034FPAY',
                requestId: uuidv4(),
                traceId: uuidv4(),
            }


            if (this.state.docs.length > 0) {
                this.state.docs.map(doc => {
                    if (doc.type == 'PAN_CARD') {
                        doc.id = this.state.panNo
                    }
                    if (doc.type == 'AADHAAR_CARD') {
                        doc.id = this.state.aadhaar
                    }
                })
            }
            var kycInfo = {
                docs: this.state.docs,
                bankKycId: '',
                acquiringBank: ''
            }

            var request = {
                header: header,
                personalInfo: this.props.personalInfo,
                shopDetails: this.state.shopDetails,
                accountInfo: null,
                kycInfo: kycInfo,
                sessionId: this.props.registerRetailerResponse.sessionId,

            }
            // const headers = {
            //     'Authorization': 'Bearer ' + this.props.token,
            //     'client-id': this.props.agentInfo.id,
            //     'role': this.props.clientRole
            // }

            console.log('save data req:' + JSON.stringify(request));

            httpClient.post(saveDataUrl, request,
                // { headers }
            ).then((response) => {
                console.log('save data response' + JSON.stringify(response.data));


                if (response.data.response.success == true) {


                    var saveData = {
                        personalInfo: this.props.personalInfo,
                        shopDetails: null,
                        accountInfo: null,
                        kycInfo: kycInfo,
                        sessionId: this.props.registerRetailerResponse.sessionId,
                    }

                    store.dispatch(setSaveData(saveData));
                    this.setState({
                        progress: 'completed'
                    })

                    var addBusinessDetailsBtn = document.getElementById('addBusinessDetailsBtn');
                    addBusinessDetailsBtn.click();


                } else {
                    this.setState({
                        saveDataErr: response.data.response.displayMsg,
                        progress: 'completed'
                    })

                }

            }).catch(error => {
                this.setState({
                    saveDataErr: 'Something went wrong',
                    progress: 'completed'
                })
                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else {

                }
    
            });
        } else {
            this.setState({
                saveDataErr: '',
                progress: 'completed'
            })
        }

    }






    render() {

        console.log(JSON.stringify(this.props.personalInfo))
        return (
            <div>
                <RegisterRetialerHeader />
                {/* <Menu /> */}
                <div class="mid-contant">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="main-heading">
                                    <h2>ID Details & Upload</h2>
                                </div>
                                <Link to='/add-business-details'>
                                    <button id='addBusinessDetailsBtn' hidden={true}></button>
                                </Link>
                            </div>

                            <div class="col-12">
                                <div class="registerbox">
                                    <div class="row mb-3">
                                        <div class="col-12 col-lg-7">
                                            <form onSubmit={this.saveData}>
                                                <div class="row">
                                                    <div class="col-12 col-lg-7">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="pan" placeholder="Enter"
                                                                value={this.state.panNo}
                                                                onChange={this.enterPANNo}
                                                            />
                                                            <label for="pan">PAN number</label>
                                                        </div>
                                                        {this.state.panErrMsg != '' &&
                                                            <div class="valid-error">
                                                                {this.state.panErrMsg}
                                                            </div>}
                                                    </div>

                                                    <div class="col-12 col-lg-5">
                                                        <div class="file-upload">
                                                            <div class="dropzone-wrapper">
                                                                <div class="dropzone-desc">
                                                                    <i class="camera"></i>
                                                                    <h6>Upload PAN</h6>
                                                                </div>
                                                                <div id="drop_zone" onDrop={this.dropHandler} onDrag={this.dragOverHandler}>
                                                                </div>
                                                                <input type="file" name="fileup" class="dropzone"
                                                                    onChange={e => this.uploadDoc(e, 'PAN')} />
                                                            </div>
                                                            {this.state.panUrl != '' &&
                                                                <img src={this.state.panUrl} alt="" class="img-fluid" />
                                                            }
                                                            {this.state.panUplodMsg != '' &&
                                                                <div class="valid-success">
                                                                    {this.state.panUplodMsg}
                                                                </div>}
                                                            {this.state.panUploadErrMsg != '' &&
                                                                <div class="valid-error">
                                                                    {this.state.panUploadErrMsg}
                                                                </div>}
                                                        </div>


                                                    </div>

                                                    <div class="col-12 col-lg-7 mt-4">
                                                        <div class="form-floating">
                                                            <input type="number" class="form-control" id="adhar" placeholder="Enter"
                                                                value={this.state.aadhaar}
                                                                onInput={(e) => e.target.value = e.target.value.slice(0, 16)}
                                                                onChange={this.enterAadhaar}
                                                            />
                                                            <label for="adhar">Aadhaar number / VID</label>
                                                        </div>
                                                        {this.state.aadhaarErrMsg != '' &&
                                                            <div class="valid-error">
                                                                {this.state.aadhaarErrMsg}
                                                            </div>}
                                                    </div>

                                                    <div class="col-12 col-lg-5 mt-4">
                                                        <div class="file-upload">
                                                            <div class="dropzone-wrapper">
                                                                <div class="dropzone-desc">
                                                                    <i class="camera"></i>
                                                                    <h6>Upload Aadhaar</h6>
                                                                </div>
                                                                <div id="drop_zone" onDrop={this.dropHandler} onDrag={this.dragOverHandler}>
                                                                </div>
                                                                <input type="file" name="fileup" class="dropzone"
                                                                    onChange={e => this.uploadDoc(e, 'Aadhaar')} />
                                                            </div>
                                                            {this.state.aadhaarUrl != '' &&
                                                                <img src={this.state.aadhaarUrl} alt="" class="img-fluid" />
                                                            }
                                                            {this.state.aadhaarUploadMsg != '' &&
                                                                <div class="valid-success">
                                                                    {this.state.aadhaarUploadMsg}
                                                                </div>}
                                                            {this.state.aadhaarUploadErrMsg != '' &&
                                                                <div class="valid-error">
                                                                    {this.state.aadhaarUploadErrMsg}
                                                                </div>}
                                                        </div>

                                                    </div>
                                                    {this.state.aadhaarUploadMsg == '' &&
                                                        <div class="col-12">
                                                            <div class="formnote">Upload Aadhaar card front and back side photo</div>
                                                        </div>
                                                    }

                                                    <div class="col-12 col-lg-5 mt-4">
                                                        <div class="file-upload">
                                                            <div class="dropzone-wrapper">
                                                                <div class="dropzone-desc">
                                                                    <i class="camera"></i>
                                                                    <h6>Profile Photo</h6>
                                                                </div>
                                                                <div id="drop_zone" onDrop={this.dropHandler} onDrag={this.dragOverHandler}>
                                                                </div>
                                                                <input type="file" name="fileup" class="dropzone"
                                                                    onChange={e => this.uploadDoc(e, 'profile')} />

                                                            </div>
                                                            {this.state.profileUrl != '' &&
                                                                <img src={this.state.profileUrl} alt="" class="img-fluid" />
                                                            }
                                                            {this.state.profileUploadMsg != '' &&
                                                                <div class="valid-success">
                                                                    {this.state.profileUploadMsg}
                                                                </div>}
                                                            {this.state.profilePhotoErrMsg != '' &&
                                                                <div class="valid-error">
                                                                    {this.state.profilePhotoErrMsg}
                                                                </div>}
                                                        </div>

                                                    </div>

                                                    {this.state.profileUploadMsg == '' &&
                                                        <div class="col-12">
                                                            <div class="formnote">upload your full face like it is a passport photo</div>
                                                        </div>
                                                    }

                                                    <div class="col-12">
                                                        <button type="submit" class="btn btn-primary" id="continue"
                                                            disabled={this.state.progress == 'loading' && true}
                                                        >Continue</button>
                                                    </div>
                                                    {this.state.saveDataErr != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.saveDataErr}
                                                        </div>
                                                    }
                                                </div>
                                            </form>
                                        </div>

                                        <div class="col-12 col-lg-5">
                                            <div class="rightbanner"><img src="images/documet-upload.png" alt="Oxigen" class="img-fluid" /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId, callBackUrl },
        retailerKycReduce: { registerRetailerResponse, personalInfo } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, agentInfo, token, clientRole,
    clientRequesterId, callBackUrl, registerRetailerResponse, personalInfo
});

export default connect(mapStateToProps, null)(UploadID);
